import Model, { attr } from '@ember-data/model';

export default class JournalReportModel extends Model {
  @attr('string') name?: string;
  @attr('string') intervalTimespan!: 'week' | 'month' | 'day';
  @attr() intervalDates?: { start: string; end: string }[];
  @attr('string') firstDayOfWeek!: string;
  // format of data is dependent on the report name
  @attr() data: any;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'all-funds/journal-report': JournalReportModel;
  }
}
